import React from 'react';
import {
  Container,
  LeftContainer,
  Image,
  StyledContainer,
  GoogleMapContainer,
  GoogleMapLeftContainer,
} from './MainContainer.styles';
import Photo from '../../assets/images/04@2x.png';
import Photo2 from '../../assets/images/03@2x.png';

import GoogleMaps from '../../components/GoogleMaps/GoogleMaps';
import { useSearchParams } from 'react-router-dom';

const MainContainer = ({ children, className }) => {
  let [searchParams] = useSearchParams();
  const tabParam = searchParams.get('step');

  return +tabParam !== 2 ? (
    <Container className={className}>
      <LeftContainer>{children}</LeftContainer>

      <Image src={tabParam >= 1 ? Photo2 : Photo} alt="loginPhoto" />
    </Container>
  ) : (
    <StyledContainer>
      <GoogleMapLeftContainer>{children}</GoogleMapLeftContainer>
      <GoogleMapContainer>
        <GoogleMaps />
      </GoogleMapContainer>
    </StyledContainer>
  );
};

export default MainContainer;
